export const TABS = ['Map', 'Tiers', 'Holds'];

export const EMD_BUTTON_BACK_VENUE_DESIGNER = 'back_venue_designer';
export const EMD_BUTTON_SAVE = 'save';
export const EMD_SAVING_MAP = 'saving_map';

export const MANAGE_HEADER_HEIGHT = 76;
export const MANAGE_FOOTER_HEIGHT = 76;
export const MANAGE_HEADER_AND_FOOTER_Z_INDEX = 1000;
export const MANAGE_CHECKOUT_PANEL_WIDTH = 350;
